var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              !_vm.isFirst
                ? _c("w-checkbox", {
                    staticClass: "mr",
                    attrs: { label: _vm.$ct("or") },
                    model: {
                      value: _vm.value.IsOr,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "IsOr", $$v)
                      },
                      expression: "value.IsOr",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "5" } },
            [
              _c("app-prop-select-autocomplete", {
                style: { flexGrow: 1 },
                attrs: { fancy: "", label: _vm.$ct("prop"), items: _vm.fields },
                model: {
                  value: _vm.value.Prop,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "Prop", $$v)
                  },
                  expression: "value.Prop",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            {
              style: { justifyContent: "center" },
              attrs: { xs: "12", md: _vm.operatorMd },
            },
            [
              _c("app-condition-operator-select", {
                attrs: {
                  condition: _vm.value,
                  fancy: "",
                  label: _vm.$ct("operator"),
                  "property-type": _vm.fieldType,
                },
              }),
            ],
            1
          ),
          _vm.hasValue
            ? _c(
                "w-col",
                { attrs: { xs: "12", md: "5" } },
                [
                  !_vm.value.UseFieldValue
                    ? _c("app-condition-value", {
                        attrs: {
                          operator: _vm.value.Operator,
                          "has-value": _vm.hasValue,
                          "field-type": _vm.fieldType,
                        },
                        model: {
                          value: _vm.value.Value,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "Value", $$v)
                          },
                          expression: "value.Value",
                        },
                      })
                    : _c("app-prop-select-autocomplete", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("prop"),
                          items: _vm.fields,
                        },
                        model: {
                          value: _vm.value.Value,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "Value", $$v)
                          },
                          expression: "value.Value",
                        },
                      }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-row", { attrs: { "no-margin": "" } }, [
                _c(
                  "div",
                  {
                    style: {
                      flexGrow: 1,
                      flexShrink: 1,
                      justifyContent: "center",
                    },
                  },
                  [
                    _c("w-checkbox", {
                      attrs: { label: _vm.$ct("use-field") },
                      model: {
                        value: _vm.value.UseFieldValue,
                        callback: function ($$v) {
                          _vm.$set(_vm.value, "UseFieldValue", $$v)
                        },
                        expression: "value.UseFieldValue",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    style: {
                      flexGrow: 0,
                      flexShrink: 0,
                      justifyContent: "center",
                    },
                  },
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("remove-condition"),
                            expression: "$ct('remove-condition')",
                          },
                        ],
                        staticClass: "danger",
                        attrs: { flat: "" },
                        on: {
                          click: function ($event) {
                            return _vm.remove()
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }